import Extension from "../base/extension";

class BooqableHelper extends Extension {
  floatingCartElement;

  constructor(name) {
    super(name);
  }

  init() {
    console.log(this.logPrefix, "BooqableHelper extension ready");

    if(!document.querySelector('#booqable-cart')) {
      this.waitFor('#booqable-cart', this.applyChanges.bind(this));
    } else {
      this.applyChanges();
    }
  }

  waitFor(selector, callback, continuous = false) {
    const observer = new MutationObserver(() => {
      const el = document.querySelector(selector);
      if (el) {
        console.log(this.logPrefix, `${selector} found`, el);
        if(!continuous) observer.disconnect();
        callback(el);
      }
    });
  
    observer.observe(document.body, { childList: true, subtree: true });
  }

  applyChanges() {
    this.floatingCartElement = document.querySelector('#booqable-cart');

    if(!this.floatingCartElement.querySelector('#booqable-sidebar-summary')) {
      this.waitFor('#booqable-sidebar-summary', this.applyChanges.bind(this), true);
      return;
    }

    console.log(this.logPrefix, "Booqable sidebar found");

    let summary = this.floatingCartElement.querySelector('#booqable-sidebar-summary');
    console.log(this.logPrefix, "Booqable sidebar summary found", summary);
    if(summary.querySelector('a[href*="/carts/"]'))
      summary.querySelector('a[href*="/carts/"]').href = "/pages/cart";
  }
}

export default BooqableHelper;